import { BaseModel } from '../../../../../../core/_base/crud';
import { FileImport } from '../../../dung-chung/__model/file-import.model';

export class PhieuNhapKho extends BaseModel {

	static category_path = "NK";
	static DEFAULT_NUMBER_VALUE = "0,00";
	static DEFAULT_LOAIPHIEU = 4;

	static optionsTinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'NK_PHIEUMOI',
			defaultChecked: true,
		},
		{
			id: 2,
			name: 'Chờ xác nhận',
			value: 'NK_CHOXACNHAN',
			defaultChecked: true,
		},
		{
			id: 3,
			name: 'Đã hủy',
			value: 'NK_DAHUY',
			defaultChecked: false,
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'NK_HOANTAT',
			defaultChecked: true,
		}
	];
	static optionsLoaiPhieu = [
		{
			value: 'NHAPTUHANGVE',
			name: 'Nhập kho hàng về từ nhà cung cấp',
			group: 'TTHV'
		},
		{
			value: 'NHAPTUDENGHI',
			name: 'Nhập kho từ nhu cầu phòng ban',
			group: 'DNNK'
		},
		{
			value: 'HANGTUKHTRAVE',
			name: 'Hàng trả về từ KH',
			group: 'DNNK'
		},
		// {
		// 	value: 'HANGTUNCCGIAO',
		// 	name: 'Hàng từ NCC giao',
		// },
		// {
		// 	value: 'HANGTUKHTRAVE',
		// 	name: 'Hàng từ KH trả về',
		// },
		// {
		// 	value: 'NHAPTUCHUYENKHO',
		// 	name: 'Nhập từ chuyển kho',
		// },
		// {
		// 	value: 'NHAPXUATDUNGLUON',
		// 	name: 'Nhập xuất dùng luôn',
		// },
		{
			value: 'BAOCAOKIEMKEDAPHEDUYET',
			name: 'Báo cáo kiểm kê đã duyệt',
			group: 'DNNK'
		}
	];

	IdNk: number
	Sophieu: string
	Ngaynhapkho: string
	Ngaytao: string
	Nguoitao: number
	TenNguoitao: string
	Nguoisua: number
	Ngaysua: string
	Tinhtrang: string
	TenTinhTrang: string
	Ghichu: string
	Nguoixacnhan: number
	TenNguoixacnhan: string
	Ngayxacnhan: string
	Nguoigiaohangxn: number
	TenNguoigiaohangxn: string
	Ngaygiaohangxn: string
	LoaiPhieu: string
	LyDo: string
	DienGiai: string
	NhapXuatLuon: number
	Attachment_Id: number
	NguoiGiaoHang: string
	PhongBanGiaoHang: string
	FileChungTu: string
	listFileChungTu: FileImport[]
	listNguoiThucHien: NguoiThucHienNhapKho[]
	listChiTietPhieuNhapKho: ChiTietPhieuNhapKho[]
	IsEnable_Duyet: boolean
	IsVisible_Duyet: boolean
	IdLoaiPhieu: number
	ChungTuKemTheo: boolean
	SoChungTu: string
	IsEnable_Huy: boolean
	IdKk: number
	SoPhieuKiemKe: string
	Customer: string
	Supplier: string
	clear() {
		this.IdNk = 0;
		this.Sophieu = '';
		this.Ngaynhapkho = '';
		this.Ngaytao = '';
		this.Nguoitao = 0;
		this.TenNguoitao = '';
		this.Nguoisua = 0;
		this.Ngaysua = '';
		this.Tinhtrang = '';
		this.TenTinhTrang = '';
		this.Ghichu = '';
		this.Nguoixacnhan = 0;
		this.TenNguoixacnhan = '';
		this.Ngayxacnhan = '';
		this.Nguoigiaohangxn = 0;
		this.TenNguoigiaohangxn = '';
		this.Ngaygiaohangxn = '';
		this.LoaiPhieu = '';
		this.LyDo = '';
		this.DienGiai = '';
		this.NhapXuatLuon = -1;
		this.Attachment_Id = 0;
		this.NguoiGiaoHang = '';
		this.PhongBanGiaoHang = '';
		this.FileChungTu = '';
		this.listNguoiThucHien = [];
		this.listChiTietPhieuNhapKho = [];
		this.listFileChungTu = []
		this.IsEnable_Duyet = false;
		this.IsVisible_Duyet = false;
		this.IdLoaiPhieu = null;
		this.SoChungTu = ''
		this.ChungTuKemTheo = false
		this.IsEnable_Huy = false;
		this.IdKk = 0
		this.SoPhieuKiemKe = ""
		this.Customer = ""
		this.Supplier = ""
	}
	copy(item: PhieuNhapKho) {
		this.IdNk = item.IdNk;
		this.Sophieu = item.Sophieu;
		this.Ngaynhapkho = item.Ngaynhapkho;
		this.Ngaytao = item.Ngaytao;
		this.Nguoitao = item.Nguoitao;
		this.TenNguoitao = item.TenNguoitao;
		this.Nguoisua = item.Nguoisua;
		this.Ngaysua = item.Ngaysua;
		this.Tinhtrang = item.Tinhtrang;
		this.TenTinhTrang = item.TenTinhTrang;
		this.Ghichu = item.Ghichu;
		this.Nguoixacnhan = item.Nguoixacnhan;
		this.TenNguoixacnhan = item.TenNguoixacnhan;
		this.Ngayxacnhan = item.Ngayxacnhan;
		this.Nguoigiaohangxn = item.Nguoigiaohangxn;
		this.TenNguoigiaohangxn = item.TenNguoigiaohangxn;
		this.Ngaygiaohangxn = item.Ngaygiaohangxn;
		this.LoaiPhieu = item.LoaiPhieu;
		this.IdLoaiPhieu = item.IdLoaiPhieu;
		this.LyDo = item.LyDo;
		this.DienGiai = item.DienGiai;
		this.NhapXuatLuon = item.NhapXuatLuon;
		this.Attachment_Id =  item.Attachment_Id;
		this.NguoiGiaoHang =  item.NguoiGiaoHang;
		this.PhongBanGiaoHang =  item.PhongBanGiaoHang;
		this.FileChungTu = item.FileChungTu;
		this.listNguoiThucHien = item.listNguoiThucHien;
		this.listChiTietPhieuNhapKho = item.listChiTietPhieuNhapKho;
		this.listFileChungTu = item.listFileChungTu;
		this.IsEnable_Duyet = item.IsEnable_Duyet;
		this.IsVisible_Duyet = item.IsVisible_Duyet;
		this.SoChungTu = item.SoChungTu;
		this.ChungTuKemTheo = item.ChungTuKemTheo;
		this.IsEnable_Huy = item.IsEnable_Huy;
		this.IdKk = item.IdKk;
		this.SoPhieuKiemKe = item.SoPhieuKiemKe
		this.Customer = this.Customer
		this.Supplier = this.Supplier
	}
}
export class ChiTietPhieuNhapKho extends BaseModel {
	IdCtnk: number
	IdNk: number
	IdHh: number
	TenHH: string
	MaHH: string
	DungSai: number
	QuyCach: string
	Dvt: number
	TenDVT: string
	IdCtdn: number
	IdNcc: number
	TenNCC: string
	MaNCC: string
	DiaChiNCC: string
	MSTNCC: string
	IdKho: number
	_oldKhoId: number
	TenKho: string
	MaKho: string
	Phieukiemtracl: string
	Tinhtrang: boolean
	Solo: string
	Soluongdn: string
	Soluongthucnhap: string
	Handung: string
	HanSuDung: string
	Ghichulohang: string
	IdTs: number
	Sopo: string
	ViTriKho: string
	NguoiXacNhan: number
	TenNguoixacnhan: string
	Ngayxacnhan: string
	Ngaynhapkho: string
	Sophieu: string
	Quyetdinhlohang: number
	IdLo: number
	KD_DatHang_Ct_Id: number
	SoMay: string
	MaSub: string
	NgaySanXat: string
	isError: boolean
	messageError: string
	NgayNhan: string
	PhongBanGiaoHang: string
	//Lưu thông tin phiếu hàng về
	IdDn: number
	SoPhieuDN: string
	Soluongchungtu: string
	LyDoChoPhepXuat: string
	LyDoKhongDuocXuat: string
	SoPOKH: string
	SoPONCC: string
	SoLuongThucNhap: string
	SoLuongPhuHop: string
	SoLuongKhongPhuHop: string
	Soluongkehoach: string
	SoLuongThucGiao: string
	HanSuDungTheoThang: number
	flagKT: boolean
	isDisableLOT: boolean
	DvtQuyDoi: number
	TenDvtQuyDoi: string
	KhoiLuongQuyDoi: number
	KhoiLuongDaNhap: number
	listDVTInfo: any[]
	MaPalletStr: string
	NotesImport: string
	IsDaLenHang: boolean
	TagInfo: string[]
	DienGiaiMaster: string
	PalletText: string
	ExpiryDate: string
	disabled: boolean
	SoXeSoMe: string
	MaThung: string
	PhongBanDeNghi: string
	LyDo: string
	ChungTuKemTheo: boolean
	SoChungTu: string
	DNNK_BoPhanNhap: string
	DNNK_PhongBanDeNghi: string
	TrangThaiChiTiet: boolean
	NgayDongThung: string
	clear() {
		this.IdCtnk = 0;
		this.IdNk = 0;
		this.IdHh = 0;
		this.TenHH = '';
		this.MaHH = '';
		this.DungSai = 0;
		this.QuyCach = '';
		this.Dvt = 0;
		this.TenDVT = '';
		this.IdCtdn = 0;
		this.IdNcc = 0;
		this.TenNCC = '';
		this.MaNCC = '';
		this.DiaChiNCC = '';
		this.MSTNCC = '';
		this.IdKho = 0;
		this.TenKho = '';
		this.MaKho = '';
		this.Phieukiemtracl = '';
		this.Tinhtrang = true;
		this.Solo = '';
		this.Soluongdn = PhieuNhapKho.DEFAULT_NUMBER_VALUE;
		this.Soluongthucnhap = PhieuNhapKho.DEFAULT_NUMBER_VALUE;
		this.Handung = '';
		this.NgayNhan = ''
		this.HanSuDung = '';
		this.Ghichulohang = '';
		this.IdTs = 0;
		this.Sopo = '';
		this.ViTriKho = '';
		this.SoPOKH = '';
		this.SoPONCC = '';
		this.NguoiXacNhan = 0;
		this.TenNguoixacnhan = '';
		this.Ngayxacnhan = '';
		this.Ngaynhapkho = '';
		this.Sophieu = '';
		this.Quyetdinhlohang = -1;
		this.IdLo = 0;
		this.KD_DatHang_Ct_Id = 0;
		this.isError = false;
		this.messageError = '';
		this.IdDn = 0;
		this.SoPhieuDN = '';
		this.Soluongchungtu = '';
		this.SoMay = '';
		this.MaSub = '';
		this.NgaySanXat = '';
		this.LyDoChoPhepXuat = '';
		this.SoLuongThucNhap = PhieuNhapKho.DEFAULT_NUMBER_VALUE;
		this.SoLuongPhuHop = '';
		this.SoLuongKhongPhuHop = '';
		this.Soluongkehoach = '';
		this.SoLuongThucGiao = '';
		this.HanSuDungTheoThang = 0;
		this.LyDoKhongDuocXuat = '';
		this.flagKT = true;
		this.isDisableLOT = false;
		this.DvtQuyDoi = 0;
		this.TenDvtQuyDoi = '';
		this.KhoiLuongQuyDoi = 0;
		this.listDVTInfo = [];
		this.MaPalletStr = '';
		this.NotesImport = "";
		this.IsDaLenHang = false;
		this.TagInfo = [];
		this.KhoiLuongDaNhap = 0;
		this.DienGiaiMaster = '';
		this.PalletText = '';
		this.ExpiryDate = '';
		this.disabled = false;
		this.SoXeSoMe = '';
		this.MaThung = ''
		this.PhongBanDeNghi = '';
		this.LyDo = ''
		this.ChungTuKemTheo = false;
		this.SoChungTu = ''
		this.PhongBanGiaoHang = ""
		this.DNNK_PhongBanDeNghi = ''
		this.DNNK_BoPhanNhap = ''
		this.TrangThaiChiTiet = false;
		this.NgayDongThung = ""
		this._oldKhoId = 0;
	}
	copy(item: ChiTietPhieuNhapKho) {
		this.IdCtnk = item.IdCtnk;
		this.IdNk = item.IdNk;
		this.IdHh = item.IdHh;
		this.TenHH = item.TenHH;
		this.MaHH = item.MaHH;
		this.DungSai = item.DungSai;
		this.QuyCach = item.QuyCach;
		this.Dvt = item.Dvt;
		this.TenDVT = item.TenDVT;
		this.IdCtdn = item.IdCtdn;
		this.IdNcc = item.IdNcc;
		this.TenNCC = item.TenNCC;
		this.MaNCC = item.MaNCC;
		this.DiaChiNCC = item.DiaChiNCC;
		this.MSTNCC = item.MSTNCC;
		this.IdKho = item.IdKho;
		this.TenKho = item.TenKho;
		this.MaKho = item.MaKho;
		this.Phieukiemtracl = item.Phieukiemtracl;
		this.Tinhtrang = item.Tinhtrang;
		this.Solo = item.Solo;
		this.Soluongdn = item.Soluongdn;
		this.Soluongthucnhap = item.Soluongthucnhap;
		this.Handung = item.Handung;
		this.HanSuDung = item.HanSuDung;
		this.NgayNhan = item.NgayNhan;
		this.Ghichulohang = item.Ghichulohang;
		this.IdTs = item.IdTs;
		this.Sopo = item.Sopo;
		this.ViTriKho = item.ViTriKho;
		this.NguoiXacNhan = item.NguoiXacNhan;
		this.TenNguoixacnhan = item.TenNguoixacnhan;
		this.Ngayxacnhan = item.Ngayxacnhan;
		this.Ngaynhapkho = item.Ngaynhapkho;
		this.Sophieu = item.Sophieu;
		this.Quyetdinhlohang = item.Quyetdinhlohang;
		this.IdLo = item.IdLo;
		this.KD_DatHang_Ct_Id = item.KD_DatHang_Ct_Id;
		this.isError = item.isError;
		this.messageError = item.messageError;
		this.IdDn = item.IdDn;
		this.SoPhieuDN = item.SoPhieuDN;
		this.Soluongchungtu = item.Soluongchungtu;
		this.SoMay = item.SoMay;
		this.MaSub = item.MaSub;
		this.NgaySanXat = item.NgaySanXat;
		this.LyDoChoPhepXuat = item.LyDoChoPhepXuat;
		this.SoLuongThucNhap = item.SoLuongThucNhap;
		this.SoLuongPhuHop = item.SoLuongPhuHop;
		this.SoLuongKhongPhuHop = item.SoLuongKhongPhuHop;
		this.Soluongkehoach = item.Soluongkehoach;
		this.SoLuongThucGiao = item.SoLuongThucGiao;
		this.HanSuDungTheoThang = item.HanSuDungTheoThang;
		this.LyDoKhongDuocXuat = item.LyDoKhongDuocXuat;
		this.flagKT = item.flagKT;
		this.isDisableLOT = item.isDisableLOT;
		this.DvtQuyDoi = item.DvtQuyDoi;
		this.TenDvtQuyDoi = item.TenDvtQuyDoi;
		this.KhoiLuongQuyDoi = item.KhoiLuongQuyDoi;
		this.listDVTInfo = item.listDVTInfo;
		this.MaPalletStr = item.MaPalletStr;
		this.NotesImport = item.NotesImport;
		this.IsDaLenHang = item.IsDaLenHang;
		this.TagInfo = [];
		if(item.TagInfo && item.TagInfo.length > 0){
			item.TagInfo.forEach(el => this.TagInfo.push(el))
		}
		this.KhoiLuongDaNhap = item.KhoiLuongDaNhap;
		this.DienGiaiMaster = item.DienGiaiMaster;
		this.PalletText = item.PalletText;
		this.ExpiryDate = item.ExpiryDate;
		this.disabled = item.disabled;
		this.SoXeSoMe = item.SoXeSoMe;
		this.MaThung = item.MaThung;
		this.PhongBanDeNghi = item.PhongBanDeNghi;
		this.LyDo = item.LyDo;
		this.ChungTuKemTheo = item.ChungTuKemTheo;
		this.SoChungTu = item.SoChungTu;
		this.SoPOKH = item.SoPOKH;
		this.SoPONCC = item.SoPONCC
		this.PhongBanGiaoHang = item.PhongBanGiaoHang;
		this.DNNK_BoPhanNhap = item.DNNK_BoPhanNhap
		this.DNNK_PhongBanDeNghi = item.DNNK_PhongBanDeNghi
		this.TrangThaiChiTiet = item.TrangThaiChiTiet;
		this.NgayDongThung = item.NgayDongThung
		this._oldKhoId = item._oldKhoId;
	}
}
export class NguoiThucHienNhapKho extends BaseModel {
	IdNk: number
	NguoiThucHien: number
	TenNguoiThucHien: string

	clear() {
		this.IdNk = 0;
		this.NguoiThucHien = 0;
		this.TenNguoiThucHien = '';
	}

	copy(item: NguoiThucHienNhapKho) {
		this.IdNk = item.IdNk;
		this.NguoiThucHien = item.NguoiThucHien;
		this.TenNguoiThucHien = item.TenNguoiThucHien;
	}
}
export class ConstantsExport {

	// .. Lock đề nghị xuất kho
	public static readonly LOCK_REQNHAPKHO          = "LOCK_REQNHAPKHO";
}
